import { useEffect, useState } from "react";
import firebase from "firebase/compat/app";

import { firebaseAppAuth } from "../lib/firebase";

export interface AuthState {
  user: firebase.User | null;
  loading: boolean;
  error: Error | null;
}

export const useAuthUser = (): AuthState => {
  const [state, setState] = useState<AuthState>({ user: null, loading: true, error: null });

  useEffect(() => {
    if (!firebaseAppAuth) {
      setState({ user: null, loading: false, error: new Error("Firebase not initialized") });
      return;
    }
    const unsubscribe = firebaseAppAuth.onAuthStateChanged(
      (authUser) => setState({ user: authUser, loading: false, error: null }),
      (error) => setState({ user: null, loading: false, error })
    );
    return unsubscribe;
  }, []);

  return state;
};
